import { getFormattedDate } from '../../../../../../../../utils/acquisition-utils';
import { useHomeAddress } from '../../../../../../providers/HomeAddressProvider';
import { usePersonalInformation } from '../../../../../../providers/PersonalInformationProvider';
import useSameAddress from './useSameAddress';
import { blackboxUtils } from '../../../../../../../../utils/blackbox-utils';

export default function usePersonalInformationForSubmit() {
    const {
        personalInformation: {
            FirstName,
            MiddleInitial,
            LastName,
            MailingAddressLine1,
            MailingAddressLine2,
            MailingCity,
            MailingState,
            MailingZipCode,
            PrimaryPhoneNumber,
            EmailAddress,
            Ssn,
            dob,
        },
    } = usePersonalInformation();
    const IsMailingHomeAddressSame = useSameAddress();
    const {
        homeAddress: {
            HomeAddressLine1,
            HomeAddressLine2,
            HomeCity,
            HomeState,
            HomeZipCode,
        },
    } = useHomeAddress();

    const dobSplit = dob.split('/');

    const formattedDOB = getFormattedDate(
        {
            month: {
                value: dobSplit[0],
            },
            day: {
                value: dobSplit[1],
            },
            year: {
                value: dobSplit[2],
            },
        },
    );
    const formattedDOBSplit = formattedDOB.split('/');

    const DOBMonth  = formattedDOBSplit[0];
    const DOBDay    = formattedDOBSplit[1];
    const DOBYear   = formattedDOBSplit[2];

    const deviceInfo = blackboxUtils.getBlackbox();

    return {
        PersonalInformation: {
            NameSuffix: '',
            FirstName,
            MiddleInitial,
            LastName,
            MailingAddressLine1,
            MailingAddressLine2,
            MailingCity,
            MailingState,
            MailingZipCode,
            IsMailingHomeAddressSame,
            MailingAddressSelectedText: '',
            HomeAddressLine1,
            HomeAddressLine2,
            HomeCity,
            HomeState: HomeState ? HomeState : null,
            HomeZipCode,
            PrimaryPhoneNumber,
            SecondaryPhoneNumber: '',
            Ssn,
            EmailAddress,
            DOBDay,
            DOBMonth,
            DOBYear,
            DateOfBirth: formattedDOB,
            IsDataEntryPage: true,
            ioBlackBox: deviceInfo && deviceInfo.Blackbox ? deviceInfo.Blackbox.ThirdParty : '',
            fpBB: deviceInfo && deviceInfo.Blackbox ? deviceInfo.Blackbox.FirstParty : '',
        },
    };
}
